const shape = {
  borderRadius: 5,
};

export default shape;
